import { render } from "./SemesterSelector.vue?vue&type=template&id=4cc7deee&scoped=true"
import script from "./SemesterSelector.vue?vue&type=script&lang=js"
export * from "./SemesterSelector.vue?vue&type=script&lang=js"

import "./SemesterSelector.vue?vue&type=style&index=0&id=4cc7deee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cc7deee"]])

export default __exports__